import { Container, Typography, Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import pca from "../index";
import ErrorIcon from "@mui/icons-material/Error";

export default function AdminUnauthorized() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  let location = useLocation();
  let navigate = useNavigate();

  const handleAgentLogout = () => {
    if (isAuthenticated) {
      window !== window.parent
        ? instance
            .logoutPopup()
            .then(() => {
              // Handle post-logout actions...
              console.log("signed out");
              window === window.parent
                ? instance
                    .loginPopup()
                    .then(() => {
                      console.log("signed in");
                    })
                    .catch((err) => {
                      console.error("canclled sign in  ", err);
                    })
                : instance
                    .logoutRedirect()
                    .then(() => {
                      console.log("signed out");
                    })
                    .catch((err) => {
                      console.error("canclled sign in  ", err);
                    });
              // window.location.reload();
            })
            .catch((error) => {
              console.error("coudln't sign out ", error);
            })
        : instance
            .logoutRedirect()
            .then(() => {
              console.log("signed out");
            })
            .catch((error) => {
              console.error("coudln't sign out ", error);
            });
    }
  };

  const showMsalPopup = async () => {
    try {
      const loginRequest = {
        scopes: ["user.read"],
        prompt: "select_account",
      };
      // Call the login popup when the button is clicked
      console.log("login request: ", loginRequest);
      window !== window.parent
        ? await pca.loginPopup(loginRequest).then((response) => {
            pca.setActiveAccount(response.account);
            location.pathname.includes("/agent/unauthorizedMsal")
              ? navigate("/agent")
              : navigate("/");
          })
        : await pca.loginRedirect(loginRequest).then((response) => {
            pca.setActiveAccount(response.account);
            location.pathname.includes("/agent/unauthorizedMsal")
              ? navigate("/agent")
              : navigate("/");
          });
    } catch (error) {
      // Handle loginPopup error
      console.error("Login popup error:", error.message);
    }
  };

  console.log("location is ***", location);
  const { language } = useLanguage();
  const pageTitle = "AdminUnauthorized";
  let popupShown = sessionStorage.getItem("loginPopupShown");

  console.log(popupShown);
  if (
    location.pathname === "/unauthorizedMsal" ||
    location.pathname === "/agent/unauthorizedMsal"
  ) {
    return (
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Box
          style={{
            maxWidth: 400,
            padding: 20,
            border: "1px solid #ccc",
            borderRadius: 8,
            textAlign: "center",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <ErrorIcon
            style={{ fontSize: 60, marginBottom: 16, color: "#f44336" }}
          />
          <Typography variant="h5" color="error" gutterBottom>
            Error Opening Popup
          </Typography>
          <Typography variant="body1" paragraph>
            This can happen if popups are blocked in your browser.
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            To allow popups, follow the instructions for your browser:
          </Typography>
          <ul style={{ textAlign: "left", paddingInlineStart: 20 }}>
            <li>
              <strong>Google Chrome:</strong>
              <ol>
                <li>Click on the lock icon in the address bar.</li>
                <li>
                  Find the "Pop-ups" setting and select "Allow" from the
                  dropdown.
                </li>
                <li>Restart your browser</li>
              </ol>
            </li>
            <li>
              <strong>Mozilla Firefox:</strong>
              <ol>
                <li> Select Settings. </li>
                <li>Click Privacy & Security located on the left side.</li>
                <li>
                  Select Block pop-up windows below the Permissions section.
                </li>
                <li>
                  To allow pop-ups for all sites, clear the check box for Block
                  pop-up windows.
                </li>
                <li>Restart your browser</li>
              </ol>
            </li>
            <li>
              <strong>Microsoft Edge:</strong>
              <ol>
                <li>
                  In Edge, go to Settings and more at the top of your browser.
                </li>
                <li>Select Settings then Cookies and site permissions.</li>
                <li>Under All permissions, select Pop-ups and redirects.</li>
                <li>Go the Allow section, and then select Add.</li>
                <li>Restart Microsoft Edge to apply the changes.</li>
              </ol>
            </li>
            {/* Add instructions for other browsers if needed */}
          </ul>
          <Button
            variant="primary"
            color="primary"
            onClick={() => {
              console.log("open popup");
              showMsalPopup();
            }}
            style={{ marginTop: 20 }}
          >
            Open Popup
          </Button>
        </Box>
      </Container>
    );
  } else {
    return (
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          textAlign: "center",
        }}
      >
        <Box style={{ maxWidth: 500 }}>
          <LockIcon
            style={{ fontSize: 60, marginBottom: 8, color: "#f44336" }}
          />
          <Typography variant="h4" color="error" gutterBottom>
            {strings[pageTitle][language].header}
          </Typography>
          <Typography variant="h5">
            {strings[pageTitle][language].body}
          </Typography>
          <Typography>{strings[pageTitle][language].footer}</Typography>
          {/* You can add more details or customize the message as needed */}
          {location.pathname === "/agent/unauthorized" && (
            <Button variant="danger" onClick={handleAgentLogout}>
              {strings[pageTitle][language].logOut}
            </Button>
          )}
          {location.pathname === "/unauthorizedMsal" && (
            <Button onClick={showMsalPopup}>Login</Button>
          )}
        </Box>
      </Container>
    );
  }
}
